<div class="resources">
    <div class="resource">
        <div class="name"></div>
        <div class="activity"></div>
    </div>
</div>